import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=0105d0dc"
import script from "./Avatar.vue?vue&type=script&lang=ts"
export * from "./Avatar.vue?vue&type=script&lang=ts"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=0105d0dc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports